/**
 * Helpers for masked provider credential display (no plaintext secrets).
 */

export function hasSavedSecurityAnswer(credInfo) {
  if (!credInfo) return false;
  if (credInfo.securityAnswerSaved === true) return true;
  if (credInfo.security_answer_saved === true) return true;
  if (credInfo.has_ssn === true) return true;
  const masked = credInfo.securityAnswerMasked || credInfo.security_answer_masked;
  return Boolean(masked && masked !== '—');
}

export function normalizeSavedCredentialInfo(apiData) {
  if (!apiData) return null;

  let cred = null;
  if (apiData.credentials?.length) {
    cred = apiData.credentials[0];
  } else if (apiData.provider || apiData.username_masked || apiData.usernameMasked) {
    cred = apiData;
  }
  if (!cred) return null;

  return {
    provider: cred.provider,
    usernameMasked:
      cred.usernameMasked || cred.username_masked || '••••••••',
    passwordSaved: Boolean(cred.passwordSaved ?? cred.password_saved ?? true),
    passwordMasked:
      cred.passwordMasked || cred.password_masked || (cred.passwordSaved || cred.password_saved ? '••••••••' : null),
    securityAnswerSaved: hasSavedSecurityAnswer({
      securityAnswerSaved: cred.securityAnswerSaved ?? cred.security_answer_saved,
      security_answer_saved: cred.security_answer_saved,
      has_ssn: cred.has_ssn,
      securityAnswerMasked: cred.securityAnswerMasked || cred.security_answer_masked,
      security_answer_masked: cred.security_answer_masked,
    }),
    securityAnswerMasked:
      cred.securityAnswerMasked
      || cred.security_answer_masked
      || (hasSavedSecurityAnswer({
        securityAnswerSaved: cred.securityAnswerSaved ?? cred.security_answer_saved,
        has_ssn: cred.has_ssn,
        securityAnswerMasked: cred.securityAnswerMasked || cred.security_answer_masked,
      }) ? '••••' : null),
    lastUsedAt: cred.last_used_at || cred.lastUsedAt,
  };
}

export function looksLikeMaskedUsername(value) {
  return Boolean(value && String(value).includes('*'));
}

/** Build normalized cred info from Settings → Connections provider row. */
export function credInfoFromSettingsProvider(provider) {
  if (!provider?.is_saved) return null;
  return {
    provider: provider.key,
    usernameMasked: provider.usernameMasked || provider.username_masked || '••••••••',
    passwordSaved: Boolean(provider.passwordSaved ?? provider.password_saved ?? true),
    passwordMasked: provider.passwordMasked || provider.password_masked || '••••••••',
    securityAnswerSaved: hasSavedSecurityAnswer({
      securityAnswerSaved: provider.securityAnswerSaved ?? provider.security_answer_saved,
      security_answer_saved: provider.security_answer_saved,
      has_ssn: provider.has_ssn,
      securityAnswerMasked: provider.securityAnswerMasked || provider.security_answer_masked,
      security_answer_masked: provider.security_answer_masked,
    }),
    securityAnswerMasked:
      provider.securityAnswerMasked
      || provider.security_answer_masked
      || (hasSavedSecurityAnswer({
        securityAnswerSaved: provider.securityAnswerSaved ?? provider.security_answer_saved,
        has_ssn: provider.has_ssn,
        securityAnswerMasked: provider.securityAnswerMasked || provider.security_answer_masked,
      }) ? '••••' : null),
    lastUsedAt: provider.last_used_at || provider.lastUsedAt,
  };
}
